export default __webpack_public_path__ + "static/media/chrome2-preview.46259ef5.png";